var map = {
  "./km.json": [
    "978669",
    "777296"
  ],
  "./ru.json": [
    "854133",
    "309771"
  ],
  "./bg.json": [
    "988078",
    "331070"
  ],
  "./el.json": [
    "998054",
    "661605"
  ],
  "./en-pt.json": [
    "518397",
    "778430"
  ],
  "./ja.json": [
    "496978",
    "777658"
  ],
  "./sv.json": [
    "984863",
    "301045"
  ],
  "./rw.json": [
    "923392",
    "188596"
  ],
  "./sr.json": [
    "284127",
    "65890"
  ],
  "./uk.json": [
    "899097",
    "344795"
  ],
  "./fr.json": [
    "720185",
    "463606"
  ],
  "./zh-hans.json": [
    "9656",
    "566163"
  ],
  "./as.json": [
    "204718",
    "45961"
  ],
  "./gu.json": [
    "892253",
    "183259"
  ],
  "./kk.json": [
    "196837",
    "767615"
  ],
  "./nb.json": [
    "84864",
    "764468"
  ],
  "./ta.json": [
    "78046",
    "678683"
  ],
  "./ky.json": [
    "802608",
    "294248"
  ],
  "./pl.json": [
    "806547",
    "52278"
  ],
  "./ro.json": [
    "112075",
    "226566"
  ],
  "./ka.json": [
    "767320",
    "648413"
  ],
  "./hu.json": [
    "730445",
    "741993"
  ],
  "./uz.json": [
    "441593",
    "60881"
  ],
  "./hy.json": [
    "346364",
    "894027"
  ],
  "./pt-pt.json": [
    "196876",
    "473171"
  ],
  "./vi.json": [
    "784809",
    "92438"
  ],
  "./tr.json": [
    "812744",
    "568402"
  ],
  "./da.json": [
    "613159",
    "108749"
  ],
  "./kn.json": [
    "269795",
    "55062"
  ],
  "./mr.json": [
    "679565",
    "412680"
  ],
  "./lt.json": [
    "905860",
    "724833"
  ],
  "./lv.json": [
    "292318",
    "946559"
  ],
  "./es.json": [
    "644429",
    "653184"
  ],
  "./ko.json": [
    "54565",
    "947219"
  ],
  "./bn.json": [
    "675207",
    "472021"
  ],
  "./cs.json": [
    "975756",
    "932203"
  ],
  "./boxes.json": [
    "321072",
    "396050"
  ],
  "./my.json": [
    "829365",
    "534867"
  ],
  "./sk.json": [
    "818582",
    "979945"
  ],
  "./nl.json": [
    "152479",
    "701358"
  ],
  "./az.json": [
    "539026",
    "637272"
  ],
  "./accents.json": [
    "292273",
    "500189"
  ],
  "./pa.json": [
    "345732",
    "720286"
  ],
  "./pt.json": [
    "858435",
    "731874"
  ],
  "./extra.json": [
    "512490",
    "118758"
  ],
  "./it.json": [
    "929536",
    "699489"
  ],
  "./hi.json": [
    "317922",
    "829692"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 222445;
module.exports = webpackAsyncContext;
